import { PlatinumLG } from './PlatinumLG';
import { PlatinumMD } from './PlatinumMD';
import { PlatinumSM } from './PlatinumSM';
import { PlatinumXL } from './PlatinumXL';

export default {
    sm: PlatinumSM,
    md: PlatinumMD,
    lg: PlatinumLG,
    xl: PlatinumXL,
};
